export const HIDDEN_KEYS = {
  sales: "hiddenSaleIds",
  stock: "hiddenStockIds",
  loans: "hiddenLoanIds",
  salary: "hiddenSalaryIds",
  expenses: "hiddenExpenseIds",
};

export function readHiddenIds(key) {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function writeHiddenIds(key, ids) {
  localStorage.setItem(key, JSON.stringify(ids.map(String)));
}

export function hideItem(key, id) {
  const ids = readHiddenIds(key);
  const sid = String(id);
  if (ids.includes(sid)) return ids;
  const next = [...ids, sid];
  writeHiddenIds(key, next);
  return next;
}

export function restoreItem(key, id) {
  const sid = String(id);
  const next = readHiddenIds(key).filter((item) => item !== sid);
  writeHiddenIds(key, next);
  return next;
}

export function isHidden(key, id) {
  return readHiddenIds(key).includes(String(id));
}

export function filterVisible(items, key) {
  const hidden = new Set(readHiddenIds(key));
  return items.filter((item) => !hidden.has(String(item.id)));
}

export function filterHidden(items, key) {
  const hidden = new Set(readHiddenIds(key));
  return items.filter((item) => hidden.has(String(item.id)));
}
